<template>
    <v-flex xs12>
        <v-card text color="grey lighten-4">
            <v-card-text>
                <span class="grey--text text--darken-2">Please confirm the following:</span>
                <v-container fluid>
                    <div class="title grey--text text--darken-2 mb-3">I certify that this data is properly obtained</div>
                    <v-layout align-center>
                        <v-checkbox v-model="permission" hide-details color="primary" class="shrink mr-2"></v-checkbox>
                        <label class="body-2 text--lighten-4">I have permission to use this data</label>
                    </v-layout>
                    <v-layout align-center>
                        <v-checkbox v-model="fea" hide-details color="primary" class="shrink mr-2"></v-checkbox>
                        <label class="body-2">This data comes from a proper source. It does not come from a Federal Election Commission filing under the Fair Elections Act</label>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
  export default {
    name: 'step-four',
    data () {
      return {
        permission: false,
        fea: false
      }
    },
    methods: {
      validation () {
        return !(!this.permission || !this.fea)
      }
    },
    watch: {
      permission () {
        this.$emit('setTerms', this.validation())
      },
      fea () {
        this.$emit('setTerms', this.validation())
      }
    }
  }
</script>
